import { first } from "rxjs/operators";
export function getValue(observable) {
    return observable.pipe(first()).toPromise();
}
